import React from 'react';

/**
 * Header do mapa de vendas — botões Voltar e Exportar PDF.
 */
function SalesMapHeader({ projectName, onClose, onExportPDF, exporting }) {
    return (
        <div className="sales-map-header">
            <div className="sales-map-header-left">
                <button className="btn btn-default" onClick={onClose} title="Voltar">
                    <i className="fas fa-arrow-left mr-1" />
                    Voltar
                </button>
                <div className="sales-map-title">
                    <i className="fas fa-map-marked-alt" />
                    Mapa de Vendas
                    {projectName && (
                        <span className="sales-map-project-name">— {projectName}</span>
                    )}
                </div>
            </div>

            <button
                className="btn btn-primary"
                onClick={onExportPDF}
                title="Exportar PDF"
                disabled={exporting}
                style={{ opacity: exporting ? 0.6 : 1 }}
            >
                <i className={exporting ? 'fas fa-spinner fa-spin mr-1' : 'fas fa-file-pdf mr-1'} />
                {exporting ? 'Gerando...' : 'Exportar PDF'}
            </button>
        </div>
    );
}

export default SalesMapHeader;
